<template>
    <div v-if="(isOnlyB2B && isb2b || !isOnlyB2B)" :class="['vue-form-element', {'has-warning': hasSoftValidationWarnings}, {'has-error': hasValidationErrors}, {'no-label': !shouldShowLabel}, cssClasses]">
        <button v-if="isHidden" type="button" class='vue-button reveal-hidden' @click="isHidden = !isHidden">
            {{ element.attributes.labelHidden }}
        </button>
        <component
            v-if="shouldShowLabel && !isHidden"
            :is="inputComponents.label"
            :context="inputProperties">
        </component>
        <template v-if="(hasIcon || isReadOnly) && !isHidden">
            <span :class="[{'icon-read-only': isReadOnly}, ...iconClasses]"></span>
        </template>
        <component
            v-if="!isHidden"
            :is="inputComponent"
            :context="inputProperties"
            :listeners="inputListeners">
        </component>
        <span v-if="hasSoftValidationWarnings && !isHidden" class="vue-input-warning">
            {{ element.softValidationErrors.join(', ') }}
        </span>
        <span v-if="hasValidationErrors && !isHidden" class="vue-input-error">
            {{ element.validationErrors.join(', ') }}
        </span>
    </div>
</template>

<script src="./vue-input.js"></script>
